import { gql } from "@apollo/client";

const PENDING_TASKS_FINANCE = gql`
  query pendingTasksFinance {
    pendingTasksFinance {
        grantsRequested
        grantsInTransit
        floatingGrants
        incomingTransactions
        outgoingTransactions
        newUsers
        onboardingUsers
        docReview
        grantsOverduePayment
    }
  }
`;

const DASHBOARD_COUNTS = gql`
  query dashboardCounts {
    dashboardCounts {
      grantsRequested
      grantsInReview
      grantsInTransit
      floatingGrants
      grantsOverduePayment
      expeditedGrants
      totalGrantsPipelineAmount
      newUsers
      onboardingUsers
      totalDonors
      totalAdvisors
      incomingTransactions
      outgoingTransactions
      orgReview
      docReview
    }
  }
`;

const DASHBOARD_ANALYTICS = gql`
  query dashboardAnalytics {
    dashboardAnalytics {
      totalAum
      previousQuarterAum
      aumChange
      totalProducts
      totalFundedProducts
      lastUpdated
      currentQuarterGrantsAmount
      previousQuarterPipelineAmount
      pipelineAmountChange
      assetUpdateRecency {
        label
        count
      }
      assetUpdateRecencyByType {
        assetType
        bins {
          label
          count
        }
      }
      averageProcessingTime
      previousQuarterProcessingTime
      processingTimeChange
      processingTimeBreakdown {
        submissionToLiquidation
        liquidationToPaymentReceived
        paymentReceivedToPaymentSent
        paymentSentToCompletion
      }
      weeklyContributions
      previousWeekContributions
      weeklyContributionsByType {
        contributionType
        count
        totalAmount
      }
      previousWeekContributionsByType {
        contributionType
        count
        totalAmount
      }
      quarterlyRevenue
      previousQuarterRevenue
      newProductsThisWeek
      previousWeekNewProducts
      auditDataAvailable
      warnings
      previousQuarterStartDate
      previousQuarterEndDate
      currentQuarterStartDate
      currentQuarterEndDate
    }
  }
`;

const TASK_COMPLETION_STATS = gql`
  query taskCompletionStats($userId: ID) {
    taskCompletionStats(userId: $userId) {
      teamCompletedThisWeek
      teamCompletedLastWeek
      teamCompletionChange
      userCompletedThisWeek
      userCompletedLastWeek
      userCompletionChange
    }
  }
`;

const VALIDATE_PASSWORD_RESET_TOKEN = gql`
query ValidatePasswordResetToken($passwordResetToken: String!) {
  validatePasswordResetToken(passwordResetToken: $passwordResetToken)
}`;


export {
  PENDING_TASKS_FINANCE,
  DASHBOARD_COUNTS,
  DASHBOARD_ANALYTICS,
  TASK_COMPLETION_STATS,
  VALIDATE_PASSWORD_RESET_TOKEN,
};
